import { useCallback } from 'react';
import { toast } from 'react-hot-toast';

interface PromotionHandlingParams {
  promotionCode: string | null;
  promotionDetails: any;
  priceBeforePromotion: number;
  getEffectivePromotionCode: (price: number) => string | null;
  paymentType: 'one_time' | 'subscription';
}

export const usePromotionHandling = () => {
  const handlePromotionCode = useCallback(async (params: PromotionHandlingParams) => {
    const {
      promotionCode,
      promotionDetails,
      priceBeforePromotion,
      getEffectivePromotionCode,
      paymentType
    } = params;

    // Add a small delay to ensure the subscription is saved in the database
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Check if promotion code is valid and compatible
    const isPromotionValid = promotionCode && promotionDetails.isValid && promotionDetails.isLoaded;
    const isPromotionCompatible = isPromotionValid && 
      (!promotionDetails.allowedPaymentTypes || 
      promotionDetails.allowedPaymentTypes.length === 0 || 
      promotionDetails.allowedPaymentTypes.includes(paymentType));
    
    // Check if the purchase meets the minimum amount requirement for the promotion
    const EPSILON = 0.001; // Small tolerance for floating point comparison
    const meetsMinimumAmount = !promotionDetails.minimumAmount || 
      priceBeforePromotion + EPSILON >= promotionDetails.minimumAmount;
    
    // Use the hook's getEffectivePromotionCode to ensure ALL validation checks are applied
    const effectivePromotionCode = getEffectivePromotionCode(priceBeforePromotion);
    
    // Show success toast only if promotion code will be applied
    if (effectivePromotionCode && promotionDetails.description) {
      // If promotion is valid and applicable, show success toast with the description
      toast.success(`Applied: ${promotionDetails.description}`);
    }

    return effectivePromotionCode;
  }, []);

  return { handlePromotionCode };
}; 